const { Core, onPlyrLoad } = Global;

customElements.define('video-player', class extends Core {
    elements = {
        $: ['player'],
        HTML5Player: 'video'
    }

    propTypes = {
        'loop': Boolean
    }

    render() {
        if (this._isYouTubeVideo()) {
            this._setupUserActionListener();
        } else {
            onPlyrLoad(this._initPlayer.bind(this));
        }
    }

    _isYouTubeVideo() {
        const provider = this.$player?.getAttribute('data-plyr-provider');
        return provider === 'youtube';
    }

    _setupUserActionListener() {
        const userEvents = { 
            touch: ["touchmove", "touchend"], 
            mouse: ["mousemove", "click", "keydown", "scroll"] 
        };

        const isTouch = () => {
            return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        };

        const actionEvents = isTouch() ? userEvents.touch : userEvents.mouse;

        const loadOnUserAction = () => {
            actionEvents.forEach((userEvent) => {
                document.removeEventListener(userEvent, loadOnUserAction);
            });
            onPlyrLoad(this._initPlayer.bind(this));
        };

        actionEvents.forEach((userEvent) => {
            document.addEventListener(userEvent, loadOnUserAction, { once: true });
        });
    }

    _initPlayer() {
        this.player = new Plyr(this.$player, {
            ratio: '16:9',
        });
        this.player.loop = this.prop('loop');
    }

    play() {
        this.player?.play();
    }

    pause() {
        this.player?.pause();
    }

    get $player() {
        return this.$('player') || this.$('HTML5Player');
    }
});
